import TextField from "./TextField";
import NumberField from "./NumberField";
import TextareaField from "./TextareaField";
import CheckboxField from "./CheckboxField";
import SelectField from "./SelectField";
import EntityField from "./EntityField";
import CoordinateField from "./CoordinateField";
import ChipsField from "./ChipsField";
import LocationPickerField from "./LocationPickerField";
import ImageField from "./ImageField";
import KeyValueField from "./KeyValueField";

export const FIELD_RENDERERS = {
  text: TextField,
  number: NumberField,
  textarea: TextareaField,
  checkbox: CheckboxField,
  select: SelectField,
  entity: EntityField,
  coordinate: CoordinateField,
  chips: ChipsField,
  location: LocationPickerField,
  image: ImageField,
  keyvalue: KeyValueField,
};

export function emptyValueFor(field) {
  switch (field.type) {
    case "checkbox": return false;
    case "number": return null;
    case "chips": return [];
    case "entity": return field.isMulti ? [] : null;
    case "coordinate": return null;
    case "location": return null;
    case "image": return null;
    case "keyvalue": return {};
    default: return "";
  }
}
